module.exports = __webpack_public_path__ + "static/media/danatech_Logo_2022.66b47477.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/danatech_Logo_2022.png
// module id = 1372
// module chunks = 0